import { FunctionComponent } from "react";
import styles from "./NotificationBanner.module.css";
import { LabelPairedXmarkSmRegularIcon } from "@deriv/quill-icons";
import NotificationStatusIcon from "../NotificationStatusIcon";

export type NotificationBannerType = {
  className?: string;
  title?: string;
  message?: string;
  showButtonClose?: boolean;
  type?: "informative" | "success" | "warning" | "danger";
  onClose?: () => void;
};

export const NotificationBanner: FunctionComponent<NotificationBannerType> = ({
  className = "",
  title = "Title",
  message = "Message goes here",
  showButtonClose = true,
  type = "informative",
  onClose,
}) => {
  const bannerId = `notification-banner-${type}`;

  return (
    <div
      className={[styles.notificationBanner, className].join(" ")}
      data-id={bannerId}
    >
      <div className={styles.containerStatusIcon}>
        <NotificationStatusIcon type={type} showBadge={false} />
      </div>
      <div className={styles.titleDescription}>
        <b className={styles.title}>{title}</b>
        <div className={styles.message}>{message}</div>
      </div>
      {showButtonClose && (
        <div className={styles.buttonClose}>
          <div
            className={`${styles.iconCustom} notification-close-icon quill-ui-next-pointer`}
            onClick={onClose}
            role={onClose ? "button" : undefined}
            tabIndex={onClose ? 0 : undefined}
          >
            <LabelPairedXmarkSmRegularIcon />
          </div>
          <div className={styles.bgFocus} />
          <div className={styles.iconColorReference}>Label</div>
        </div>
      )}
    </div>
  );
};

export default NotificationBanner;
